export const SET_TOASTS = 'SET_TOASTS';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const ADD_TOAST = 'ADD_TOAST';

export const setToasts = (toasts) => ({
    toasts,
    type: SET_TOASTS,
});

export const removeToast = (toastId) => ({
    type: REMOVE_TOAST,
    toastId,
});

export const addToast = (toast) => ({
    type: ADD_TOAST,
    toast,
});